import React from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';
import { FormattedMessage } from 'react-intl';
import get from 'lodash.get';
import { pageTypeConstants as pageTypes } from '../../constants/pageTypeConstants';
import { SbSharedLink } from '../SbSharedLink/SbSharedLink';

function SbSharedSearchRedirectNoticeComponent(props) {
    const { itemSearch } = props;
    const newQuery = get(itemSearch, 'spellCheck.newQuery');
    const oldQuery = get(itemSearch, 'spellCheck.oldQuery');
    const redirect = get(itemSearch, 'spellCheck.redirect');

    if (itemSearch.pageType !== pageTypes.SEARCH || !redirect || !oldQuery) {
        return null;
    }

    return (
        <div className={props.className}>
            <FormattedMessage
                id="sb.SbSharedSearchRedirectNotice.redirectNotice"
                defaultMessage={`0 results for "{oldQuery}", so we searched for "{newQuery}".`}
                values={{ oldQuery, newQuery }}
            />{' '}
            <SbSharedLink href={redirect.redirectFrom}>
                <FormattedMessage
                    id="sb.SbSharedSearchRedirectNotice.return"
                    defaultMessage={`Return to original search`}
                />
            </SbSharedLink>
        </div>
    );
}

SbSharedSearchRedirectNoticeComponent.propTypes = {
    itemSearch: PropTypes.shape({
        pageType: PropTypes.string.isRequired,
        newQuery: PropTypes.string,
        oldQuery: PropTypes.string,
        redirect: PropTypes.shape({
            redirectFrom: PropTypes.string.isRequired,
        }),
    }),
    className: PropTypes.string,
};

export const SbSharedSearchRedirectNotice = createFragmentContainer(
    SbSharedSearchRedirectNoticeComponent,
    {
        itemSearch: graphql`
            fragment SbSharedSearchRedirectNotice_itemSearch on ItemSearchQueryConnection {
                pageType
                spellCheck {
                    newQuery
                    oldQuery
                    redirect {
                        redirectFrom
                    }
                }
            }
        `,
    }
);
